/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import shapefileHelper from "./shapefile.js";

var selectFileOptions =  {
	accept: shapefileHelper.selectFileOptions.accept + ",.csv,.xlsx",
	multiple: true
};

function checkFiles(importType, files) {
	var issues = [];

	
	if(files.length == 1 && files[0].name.match(/.csv$/)) {
		issues.push({
			message: "CSV file detected - OK",
			type: "Info"
		});
	} else if(files.length == 1 && files[0].name.match(/.xlsx/)) {
		issues.push({
			message: "Excel spreadsheet detected - OK",
			type: "Info"
		});
	} else {
		return shapefileHelper.checkFiles(importType, files);
	}

	return Promise.resolve(issues);
}

export default {
	selectFileOptions,
	checkFiles
};
